/* eslint-disable no-nested-ternary */
/* eslint-disable no-unused-vars */
/**
 * © [2022] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
export const ALL_ACC_REC_NDC_TABLE = 'ALL_ACC_REC_NDC_TABLE';
export const ALL_ACC_REC_FIELD_VALUES = 'ALL_ACC_REC_FIELD_VALUES';
export const ACC_REBATE_PGM = 'ACC_REBATE_PGM';
export const ACC_REBATE_PGM_NAME = 'ACC_REBATE_PGM_NAME';
export const QTR_ACCOUNT_REC_ALL_FIELD_CLEAR_REDUX =
  'QTR_ACCOUNT_REC_ALL_FIELD_CLEAR_REDUX';
